// ===========================
// Ivy Cove - Custom JavaScript
// ===========================

$(document).ready(function () {

    // ===== Hamburger Menu =====
    $('.hamburger').on('click', function () {
        $(this).toggleClass('active');
        $('.mobile-nav').addClass('active');
        $('.nav-overlay').addClass('active');
        $('body').css('overflow', 'hidden');
    });

    $('.nav-overlay, .mobile-nav-close').on('click', function () {
        $('.hamburger').removeClass('active');
        $('.mobile-nav').removeClass('active');
        $('.nav-overlay').removeClass('active');
        $('body').css('overflow', '');
    });

    // // ===== Mobile Nav Dropdowns (2nd level) =====
    // $('.mobile-has-dropdown > a .mobile-arrow').on('click', function (e) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     var $parent = $(this).closest('.mobile-has-dropdown');
    //     if ($parent.hasClass('open')) {
    //         $parent.removeClass('open');
    //     } else {
    //         $('.mobile-has-dropdown').removeClass('open');
    //         $parent.addClass('open');
    //     }
    // });

    // // ===== Mobile Nav Sub-Dropdowns (3rd level) =====
    // $(document).on('click', '.mobile-has-subdropdown > a .mobile-arrow--sub', function (e) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     var $parent = $(this).closest('.mobile-has-subdropdown');
    //     $parent.toggleClass('open');
    // });
// ===== Mobile Nav Dropdowns (2nd level) =====
$(document).on('click', '.mobile-has-dropdown > .mhd_link > .mobile-arrow', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $parent = $(this).closest('.mobile-has-dropdown');

    // sirf top level dropdowns close hon
    $('.mobile-has-dropdown').not($parent).removeClass('open');

    $parent.toggleClass('open');
});


// ===== Mobile Nav Sub-Dropdowns (3rd level) =====
$(document).on('click', '.mobile-has-subdropdown > .mhd_link > .mobile-arrow--sub', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $parent = $(this).closest('.mobile-has-subdropdown');

    $parent.toggleClass('open');
});
    // ===== Header Shadow on Scroll =====
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 10) {
            $('#header').addClass('scrolled');
        } else {
            $('#header').removeClass('scrolled');
        }
    });

    // ===== Category Carousel =====
    var catCarousel = $('.category-carousel').owlCarousel({
        loop: true,
        margin: 24,
        nav: false,
        dots: false,
        responsive: {
            0: { items: 1 },
            480: { items: 2 },
            768: { items: 3 },
            992: { items: 4 }
        }
    });

    $('.cat-prev').on('click', function () {
        catCarousel.trigger('prev.owl.carousel');
    });
    $('.cat-next').on('click', function () {
        catCarousel.trigger('next.owl.carousel');
    });

    // ===== Best Sellers Carousel =====
    var bsCarousel = $('.best-sellers-carousel').owlCarousel({
        loop: true,
        margin: 16,
        nav: false, 
        dots: false,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplaySpeed: 1200,
        smartSpeed: 1200,
        autoplayHoverPause: true,
        responsive: {
            0: { items: 2, margin: 16 },
            768: { items: 3, margin: 16 },
            992: { items: 4, margin: 16 },
            1200: { items: 5, margin: 24 },
            1366: { items: 5, margin: 24 }
        }
    });

    $('.bs-prev').on('click', function () {
        bsCarousel.trigger('prev.owl.carousel');
    });
    $('.bs-next').on('click', function () {
        bsCarousel.trigger('next.owl.carousel');
    });

    // ===== Reviews Carousel =====
    var revCarousel = $('.reviews-carousel').owlCarousel({
        loop: true,
        margin: 24,
        nav: false,
        dots: false,
        responsive: {
            0: { items: 1 },
            480: { items: 2 },
            768: { items: 2 },
            992: { items: 3 },
            1200: { items: 4 }
        }
    });

    $('.rev-prev').on('click', function () {
        revCarousel.trigger('prev.owl.carousel');
    });
    $('.rev-next').on('click', function () {
        revCarousel.trigger('next.owl.carousel');
    });

    // ===== Sustainability Gallery Carousel =====
    $('.sust-gallery-carousel').owlCarousel({
        loop: true,
        margin: 24,
        nav: false,
        dots: false,
        center: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplaySpeed: 800,
        smartSpeed: 800,
        autoplayHoverPause: true,
        responsive: {
            0: { items: 1, stagePadding: 40 },
            480: { items: 2, stagePadding: 30 },
            768: { items: 3, stagePadding: 40 },
            992: { items: 3, stagePadding: 40 },
            1200: { items: 4, stagePadding: 60 }
        }
    });

    // ===== Community / Collection Products Load More (batches + AJAX pagination) =====
    // Wrapped in initCommLoadMore() so we can re-initialize after Dawn's facets
    // re-renders the section on filter/sort changes (which replaces #commGrid).
    function initCommLoadMore() {
        var $commGrid = $('#commGrid');
        if (!$commGrid.length) return;

        var $commLoader = $('#commLoading');
        var commInitial = parseInt($commLoader.data('initial'), 10) || 8;
        var commBatch = parseInt($commLoader.data('batch'), 10) || 4;
        var commLoading = false;

        // Collection pages (Dawn) wrap each product in <li class="grid__item">.
        // Community/wineries/hotels pages render flat .comm-product-card divs.
        var $allCards = $commGrid.find('> ul > li.grid__item');
        if (!$allCards.length) {
            $allCards = $commGrid.find('.comm-product-card');
        }
        // Hide cards beyond initial count
        $allCards.each(function (i) {
            if (i >= commInitial) {
                $(this).addClass('comm-product-hidden');
            }
        });
        refreshCommLoaderState();

        function refreshCommLoaderState() {
            var hasHidden = $commGrid.find('.comm-product-hidden').length > 0;
            var hasNext = !!$commLoader.attr('data-next-url');
            if (!hasHidden && !hasNext) {
                $commLoader.addClass('comm-loading-done');
            } else {
                $commLoader.removeClass('comm-loading-done');
            }
        }

        function fetchCommNextPage(done) {
            var nextUrl = $commLoader.attr('data-next-url');
            if (!nextUrl) { done(0); return; }
            $.get(nextUrl).done(function (html) {
                var $doc = $('<div>').html(html);
                var $newCards = $doc.find('#commGrid > ul > li.grid__item');
                if (!$newCards.length) {
                    $newCards = $doc.find('#commGrid .comm-product-card');
                }
                if ($newCards.length) {
                    $newCards.removeClass('comm-product-reveal').addClass('comm-product-hidden');
                    var $appendTarget = $commGrid.find('> ul').first();
                    if (!$appendTarget.length) $appendTarget = $commGrid;
                    $appendTarget.append($newCards);
                }
                var newNext = $doc.find('#commLoading').attr('data-next-url') || '';
                if (newNext) {
                    $commLoader.attr('data-next-url', newNext);
                } else {
                    $commLoader.removeAttr('data-next-url');
                }
                done($newCards.length);
            }).fail(function () { done(0); });
        }

        function checkCommLoad() {
            if (commLoading) return;
            if (!$commLoader.length || !document.contains($commLoader[0]) || $commLoader.hasClass('comm-loading-done')) return;
            var loaderTop = $commLoader.offset().top;
            var viewBottom = $(window).scrollTop() + $(window).height();
            if (loaderTop < viewBottom - 30) {
                commLoading = true;
                setTimeout(function () {
                    var $hidden = $commGrid.find('.comm-product-hidden');
                    if ($hidden.length > 0) {
                        $hidden.slice(0, commBatch).removeClass('comm-product-hidden').addClass('comm-product-reveal');
                        refreshCommLoaderState();
                        commLoading = false;
                    } else if ($commLoader.attr('data-next-url')) {
                        fetchCommNextPage(function (appendedCount) {
                            if (appendedCount > 0) {
                                $commGrid.find('.comm-product-hidden').slice(0, commBatch)
                                    .removeClass('comm-product-hidden').addClass('comm-product-reveal');
                            }
                            refreshCommLoaderState();
                            commLoading = false;
                        });
                    } else {
                        $commLoader.addClass('comm-loading-done');
                        commLoading = false;
                    }
                }, 200);
            }
        }

        // Unbind any previous scroll handler before binding fresh — when
        // re-initialized after a Dawn facet render, the old handler still
        // points at a detached DOM and must not double-fire.
        $(window).off('scroll.commLoad').on('scroll.commLoad', checkCommLoad);
        checkCommLoad();
    }

    initCommLoadMore();

    // When Dawn's facets.js applies a filter/sort, it replaces the section's
    // inner HTML — that means #commGrid is removed and a fresh #commGrid is
    // added by the response. Watch for that and re-run our init so the new
    // grid gets its hidden / loader / scroll behavior.
    if (window.MutationObserver) {
        var commObserverTarget = document.querySelector('main#MainContent, main, body');
        if (commObserverTarget) {
            var commReinitTimer = null;
            var commObserver = new MutationObserver(function (mutations) {
                var needsReinit = false;
                for (var i = 0; i < mutations.length; i++) {
                    var added = mutations[i].addedNodes;
                    for (var j = 0; j < added.length; j++) {
                        var node = added[j];
                        if (node.nodeType !== 1) continue;
                        if (node.id === 'commGrid' || (node.querySelector && node.querySelector('#commGrid'))) {
                            needsReinit = true;
                            break;
                        }
                    }
                    if (needsReinit) break;
                }
                if (needsReinit) {
                    if (commReinitTimer) clearTimeout(commReinitTimer);
                    commReinitTimer = setTimeout(function () {
                        commReinitTimer = null;
                        initCommLoadMore();
                    }, 80);
                }
            });
            commObserver.observe(commObserverTarget, { childList: true, subtree: true });
        }
    }

    // ===== Press Page: Tabs + Load More =====
    var $pressGrid = $('#pressGrid');
    var $pressLoadMore = $('#pressLoadMore');
    var pressInitial = parseInt($pressLoadMore.data('initial'), 10) || 9;
    var pressBatch = parseInt($pressLoadMore.data('batch'), 10) || 3;

    if ($pressGrid.length) {
        var $allPress = $pressGrid.find('.press-card');
        var activeCategory = 'all';

        function pressApplyFilter() {
            var count = 0;
            $allPress.removeClass('press-card-hidden press-card-reveal').css('display', '');
            $allPress.each(function () {
                var tags = $(this).data('tags') || '';
                if (activeCategory === 'all' || tags.indexOf(activeCategory) !== -1) {
                    count++;
                    if (count > pressInitial) {
                        $(this).addClass('press-card-hidden');
                    }
                } else {
                    $(this).css('display', 'none');
                }
            });
            var hiddenLeft = $pressGrid.find('.press-card-hidden').length;
            if (hiddenLeft > 0) {
                $('#pressLoadMore').removeClass('press-all-loaded');
            } else {
                $('#pressLoadMore').addClass('press-all-loaded');
            }
        }

        pressApplyFilter();

        // Tab click
        $('.press-tab').on('click', function () {
            $('.press-tab').removeClass('active');
            $(this).addClass('active');
            activeCategory = $(this).data('category');
            pressApplyFilter();
        });

        // Load More click
        $('#pressLoadBtn').on('click', function () {
            var $hidden = $pressGrid.find('.press-card-hidden');
            $hidden.slice(0, pressBatch).removeClass('press-card-hidden').addClass('press-card-reveal');
            if ($pressGrid.find('.press-card-hidden').length === 0) {
                $('#pressLoadMore').addClass('press-all-loaded');
            }
        });
    }

    // Collection filter + sort are now handled by Dawn's native facets.js
    // (loaded by the main-collection-product-grid section). No custom AJAX here.

    // ===== Copy link (article share) =====
    $(document).on('click', '.js-copy-link', function (e) {
        e.preventDefault();
        var url = $(this).data('url') || $(this).attr('href');
        if (navigator.clipboard && url) {
            navigator.clipboard.writeText(url).then(function () {
                var $btn = $(e.currentTarget);
                $btn.addClass('copied');
                setTimeout(function () { $btn.removeClass('copied'); }, 1500);
            });
        }
    });

    // ===== FAQ Accordion =====
    $('.faq-question').on('click', function () {
        var $item = $(this).closest('.faq-item');
        if ($item.hasClass('active')) {
            $item.removeClass('active');
        } else {
            $item.siblings('.faq-item').removeClass('active');
            $item.addClass('active');
        }
    });

    // ===== Lifestyle Gallery =====
    var $galleryGrid = $('#galleryGrid');
    var $galleryLoader = $('#galleryLoading');
    var galleryInitial = parseInt($galleryLoader.data('initial'), 10) || 16;
    var galleryBatch = parseInt($galleryLoader.data('batch'), 10) || 8;

    if ($galleryGrid.length) {
        var $allGallery = $galleryGrid.find('.gallery-item');
        var galleryCategory = 'all';
        var galleryLoading = false;

        // Fancybox lightbox (optional — no-op if plugin not loaded)
        if (typeof $.fancybox !== 'undefined') {
            $.fancybox.defaults.animationEffect = 'fade';
            $.fancybox.defaults.buttons = ['zoom', 'slideShow', 'fullScreen', 'close'];
        }

        function galleryApplyFilter() {
            var count = 0;
            $allGallery.removeClass('gallery-item-hidden gallery-item-reveal').css('display', '');
            $allGallery.each(function () {
                var tags = $(this).data('tags') || '';
                if (galleryCategory === 'all' || tags.indexOf(galleryCategory) !== -1) {
                    count++;
                    if (count > galleryInitial) {
                        $(this).addClass('gallery-item-hidden');
                    }
                } else {
                    $(this).css('display', 'none');
                }
            });
            if ($galleryGrid.find('.gallery-item-hidden').length > 0) {
                $galleryLoader.removeClass('comm-loading-done');
            } else {
                $galleryLoader.addClass('comm-loading-done');
            }
        }

        galleryApplyFilter();

        // Tab click (use press-tab class on gallery page)
        $('.gallery-section .press-tab').on('click', function () {
            $('.gallery-section .press-tab').removeClass('active');
            $(this).addClass('active');
            galleryCategory = $(this).data('category');
            galleryApplyFilter();
            // Smooth fade-in on visible items
            $galleryGrid.find('.gallery-item').not('.gallery-item-hidden').css('opacity', '0').each(function (i) {
                var $el = $(this);
                setTimeout(function () {
                    $el.css({ opacity: '1', transition: 'opacity 0.4s ease, transform 0.4s ease', transform: 'translateY(0)' });
                }, i * 50);
            });
        });

        // Scroll load more
        function checkGalleryLoad() {
            if (galleryLoading) return;
            if (!$galleryLoader.length || $galleryLoader.hasClass('comm-loading-done')) return;
            var loaderTop = $galleryLoader.offset().top;
            var viewBottom = $(window).scrollTop() + $(window).height();
            if (loaderTop < viewBottom - 30) {
                galleryLoading = true;
                setTimeout(function () {
                    var $hidden = $galleryGrid.find('.gallery-item-hidden');
                    $hidden.slice(0, galleryBatch).removeClass('gallery-item-hidden').addClass('gallery-item-reveal');
                    if ($galleryGrid.find('.gallery-item-hidden').length === 0) {
                        $galleryLoader.addClass('comm-loading-done');
                    }
                    galleryLoading = false;
                }, 3000);
            }
        }
        checkGalleryLoad();
        $(window).on('scroll', checkGalleryLoad);
    }

    // ===== Collection Category Carousel =====
    // Viewport-aware slider activation. The Liquid section renders the
    // grid markup by default; we upgrade it to Owl only when the current
    // viewport's threshold is exceeded:
    //   desktop  (>= 1201px): slider when total > 6
    //   tablet   (601-1200) : slider when total > 4
    //   mobile   (<=  600px): slider when total > 2
    // Re-evaluates on resize (debounced) and toggles cleanly between
    // grid and slider without breaking other init code.
    var $colCarousel = $('.collection-cats-carousel');
    if ($colCarousel.length) {
        var colTotal = $colCarousel.find('.item').length;
        var $colNav = $('.collection-cats-nav');
        var colCurrent = 1;
        var colCatInstance = null;

        function colShouldUseSlider() {
            var w = window.innerWidth;
            if (w <= 600) return colTotal > 2;
            if (w <= 1200) return colTotal > 4;
            return colTotal > 6;
        }

        function colUpdateNav() {
            $colNav.find('.collection-cat-current').text(colCurrent < 10 ? '0' + colCurrent : colCurrent);
            $colNav.find('.collection-cat-total').text(colTotal < 10 ? '0' + colTotal : colTotal);
            $colNav.find('.collection-cat-progress-bar').css('width', (colCurrent / colTotal * 100) + '%');
        }

        function colInitSlider() {
            if (colCatInstance) return;
            $colCarousel.removeClass('is-grid is-grid-cap-' + colTotal).addClass('owl-carousel owl-theme');
            colCurrent = 1;
            colUpdateNav();

            // Bind BEFORE init so Owl emits the first translated event into our handler.
            // `changed.owl.carousel` fires on any slide change: arrow, swipe/drag, autoplay.
            // event.item.index is the cloned-index in loop mode, so we resolve it to the
            // real (0-based) index via relatedTarget.relative().
            $colCarousel.on('changed.owl.carousel', function (event) {
                if (!event || !event.relatedTarget) return;
                var realIndex = event.relatedTarget.relative(event.item.index);
                if (typeof realIndex !== 'number' || isNaN(realIndex)) return;
                if (realIndex < 0) realIndex = (realIndex % colTotal + colTotal) % colTotal;
                colCurrent = (realIndex % colTotal) + 1;
                colUpdateNav();
            });

            colCatInstance = $colCarousel.owlCarousel({
                loop: true,
                margin: 24,
                nav: false,
                dots: false,
                smartSpeed: 600,
                responsive: {
                    0:    { items: 2 },
                    480:  { items: 3 },
                    768:  { items: 4 },
                    992:  { items: 5 },
                    1200: { items: 6 }
                }
            });
            $colNav.show();
        }

        function colDestroySlider() {
            if (!colCatInstance) return;
            $colCarousel.off('changed.owl.carousel');
            $colCarousel.trigger('destroy.owl.carousel');
            $colCarousel.removeClass('owl-carousel owl-theme owl-loaded owl-drag').addClass('is-grid is-grid-cap-' + colTotal);
            $colNav.hide();
            colCatInstance = null;
        }

        function colApplyMode() {
            if (colShouldUseSlider()) {
                colInitSlider();
            } else {
                colDestroySlider();
            }
        }

        // Nav click handlers bound once; they no-op if slider is not active.
        // Counter is updated by the `changed.owl.carousel` event bound in colInitSlider,
        // so click + swipe + drag all converge on the same single source of truth.
        $('.collection-cat-prev').on('click', function () {
            if (!colCatInstance) return;
            colCatInstance.trigger('prev.owl.carousel');
        });
        $('.collection-cat-next').on('click', function () {
            if (!colCatInstance) return;
            colCatInstance.trigger('next.owl.carousel');
        });

        colApplyMode();

        var colResizeTimer = null;
        $(window).on('resize', function () {
            if (colResizeTimer) clearTimeout(colResizeTimer);
            colResizeTimer = setTimeout(colApplyMode, 200);
        });
    }

    // ===== Lifestyle Tag Popup =====
    var lifestyleProducts = [
        { img: 'images/product-tote.png', name: 'The Classic Tote', price: '$171.00 USD' },
        { img: 'images/product-tote.png', name: 'Sag Harbor Tote', price: '$186.00 USD' },
        { img: 'images/product-tote.png', name: 'Solana Bucket Bag', price: '$148.00 USD' },
        { img: 'images/product-tote.png', name: 'Carova Camera Bag', price: '$126.00 USD' },
        { img: 'images/product-tote.png', name: 'East West Leather Tote', price: '$148.00 USD' }
    ];
    var $lifeWrap = $('.lifestyle-wrap');
    var $lifeCard = $lifeWrap.find('.lifestyle-product-card');

    function closeLifestylePopup() {
        $lifeWrap.find('.lifestyle-tag').removeClass('active');
        $lifeCard.removeClass('active');
        setTimeout(function () { $lifeCard.css('display', 'none'); }, 300);
    }

    function positionLifestyleCardNearTag($tag) {
        // iPad and mobile (<=989px) keep their centered position (see CSS
        // media queries lower in this file). Only on real desktop do we
        // anchor the popup BELOW the clicked dot, centered horizontally on
        // the dot. Falls back to ABOVE the dot if the popup would overflow
        // the bottom of the lifestyle image.
        if (window.innerWidth <= 989) {
            // Strip any inline coords we may have set on a previous (desktop)
            // open so the responsive CSS centering can take over cleanly.
            $lifeCard.css({ left: '', top: '', right: '', margin: '', transform: '' });
            return;
        }
        var wrapEl = $lifeWrap[0];
        var tagEl = $tag[0];
        if (!wrapEl || !tagEl) return;

        var wrapRect = wrapEl.getBoundingClientRect();
        var tagRect = tagEl.getBoundingClientRect();
        // Position relative to the wrap (which is position: relative).
        var dotCenterX = tagRect.left - wrapRect.left + tagRect.width / 2;
        var dotBottom = tagRect.top - wrapRect.top + tagRect.height;
        var dotTop = tagRect.top - wrapRect.top;

        var cardW = $lifeCard.outerWidth() || 220;
        var cardH = $lifeCard.outerHeight() || 260;
        var gap = 14;

        // Default: BELOW the dot, horizontally centered on it.
        var left = dotCenterX - cardW / 2;
        var top = dotBottom + gap;

        // If it would overflow the bottom edge, flip to ABOVE the dot.
        if (top + cardH > wrapRect.height - 8) {
            top = dotTop - cardH - gap;
        }
        // Clamp horizontally inside the wrap so it never gets cut off.
        if (left < 8) left = 8;
        if (left + cardW > wrapRect.width - 8) left = wrapRect.width - cardW - 8;
        // Clamp vertically too (e.g. dot very near the top of the image).
        if (top < 8) top = 8;

        $lifeCard.css({
            left: left + 'px',
            top: top + 'px',
            right: 'auto',
            margin: 0,
            transform: 'scale(0.95)'
        });
    }

    function showLifestylePopup(productIdx, $tag) {
        // Prefer live product data on the tag (data-* attributes rendered from Shopify).
        // Fall back to the hardcoded lifestyleProducts array if a tag has none.
        var name = $tag.data('name');
        var price = $tag.data('price');
        var img = $tag.data('img');
        var url = $tag.data('url');

        if (!name) {
            var fallback = lifestyleProducts[productIdx] || lifestyleProducts[0];
            if (!fallback) return;
            name = fallback.name;
            price = fallback.price;
            img = fallback.img;
            url = '#';
        }
        if (!url) url = '#';

        $lifeWrap.find('.lifestyle-tag').removeClass('active');
        $tag.addClass('active');

        $lifeCard.find('.lifestyle-product-link').attr('href', url);
        $lifeCard.find('.lifestyle-product-img img').attr('src', img).attr('alt', name);
        $lifeCard.find('.lifestyle-product-info h4').text(name);
        $lifeCard.find('.lifestyle-product-info p').text(price);
        $lifeCard.css('display', 'flex');
        // Measure once visible, then animate to scale(1) via .active class.
        positionLifestyleCardNearTag($tag);
        setTimeout(function () {
            positionLifestyleCardNearTag($tag);
            $lifeCard.addClass('active');
        }, 20);
    }

    // Reposition on window resize so the popup tracks its dot.
    $(window).on('resize', function () {
        var $active = $lifeWrap.find('.lifestyle-tag.active');
        if ($active.length && $lifeCard.hasClass('active')) {
            positionLifestyleCardNearTag($active);
        }
    });

    // Default: open the last tag that actually has a product
    var $defaultTag = $lifeWrap.find('.lifestyle-tag[data-name]').last();
    if (!$defaultTag.length) $defaultTag = $('.lifestyle-tag.tag-5');
    if ($defaultTag.length) {
        var defaultIdx = parseInt($defaultTag.data('product')) - 1;
        if (isNaN(defaultIdx)) defaultIdx = 4;
        showLifestylePopup(defaultIdx, $defaultTag);
    }

    $('.lifestyle-tag').on('click', function (e) {
        e.stopPropagation();
        var $tag = $(this);
        var idx = parseInt($tag.data('product')) - 1;
        // If same tag — toggle close
        if ($tag.hasClass('active')) {
            closeLifestylePopup();
            return;
        }
        // Close first, then open new
        $lifeCard.removeClass('active').css('display', 'none');
        showLifestylePopup(idx, $tag);
    });

    // No close on outside click — only closes when another tag is clicked

    // ===== Filter Dropdowns =====
    $('.filter-btn[data-dropdown]').on('click', function (e) {
        e.stopPropagation();
        var targetId = $(this).data('dropdown');
        var $dropdown = $('#' + targetId);
        var wasActive = $dropdown.hasClass('active');
        // Close all dropdowns first
        $('.filter-dropdown').removeClass('active');
        // Toggle clicked one
        if (!wasActive) {
            $dropdown.addClass('active');
        }
    });

    // Close dropdowns on outside click
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.filter-dropdown-wrap').length) {
            $('.filter-dropdown').removeClass('active');
        }
    });

    // Sort option click
    $('.sort-option').on('click', function (e) {
        e.preventDefault();
        $(this).siblings('.sort-option').removeClass('active');
        $(this).addClass('active');
        $('.filter-dropdown').removeClass('active');
    });

    // ===== Scroll Fade-in Animation =====
    function checkFadeIn() {
        $('.fade-in').each(function () {
            var elemTop = $(this).offset().top;
            var viewBottom = $(window).scrollTop() + $(window).height();
            if (elemTop < viewBottom - 60) {
                $(this).addClass('visible');
            }
        });
    }

    checkFadeIn();
    $(window).on('scroll', checkFadeIn);

});

// ===== Product detail main-gallery prev/next arrows =====
// The main slider is now Swiper-driven (see "Swiper.js powered" block).
// Arrow buttons drive the Swiper directly. We don't touch the small
// thumbnail-strip's own arrows.
(function () {
  function findMainGallery(btn) {
    var gallery = btn.closest('product-info media-gallery');
    if (!gallery) return null;
    var slider = btn.closest('slider-component');
    if (slider && slider.classList.contains('thumbnail-slider')) return null;
    return gallery;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.slider-button--prev, .slider-button--next');
    if (!btn) return;
    var gallery = findMainGallery(btn);
    if (!gallery) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
    var swiper = gallery.__ivySwiper;
    if (!swiper) return;
    if (btn.classList.contains('slider-button--next')) swiper.slideNext();
    else swiper.slidePrev();
  }, true);
})();

// ===== Product detail lightbox — powered by Fancybox 3 =====
// We bypass Dawn's <product-modal> entirely. Clicking the main product
// image (or its fullscreen icon) opens a Fancybox gallery with all of
// the product's media. Fancybox 3.5.7 already ships with built-in
// pointer/touch swipe + zoom + arrow keys + close on backdrop, so we
// don't have to wire any of that ourselves. The Dawn modal is kept in
// the DOM (so Dawn's own code doesn't error) but is hidden via CSS.
(function () {
  if (typeof jQuery === 'undefined' || typeof jQuery.fancybox === 'undefined') return;

  function collectSlides(productInfo) {
    // Each visible slide on the main product is a <li class="product__media-item"
    // data-media-id="...">. Inside it, the high-res image lives at the largest
    // `srcset` candidate. Walk in DOM order to preserve gallery order.
    var slides = [];
    productInfo.querySelectorAll('.product__media-list .product__media-item[data-media-id]').forEach(function (li) {
      var img = li.querySelector('img.global-media-settings, img');
      if (!img) return;
      // Pick the highest-resolution URL we can find.
      var src = img.currentSrc || img.src;
      // If srcset has a 2048+ width candidate, prefer it for clarity.
      var srcset = img.getAttribute('srcset') || '';
      var bestUrl = src;
      var bestW = 0;
      srcset.split(',').forEach(function (part) {
        var m = part.trim().match(/^(\S+)\s+(\d+)w$/);
        if (m) {
          var w = parseInt(m[2], 10);
          if (w > bestW) { bestW = w; bestUrl = m[1]; }
        }
      });
      slides.push({
        src: bestUrl,
        thumb: src,
        opts: { caption: img.getAttribute('alt') || '' },
        mediaId: li.getAttribute('data-media-id')
      });
    });
    return slides;
  }

  function findStartIndex(slides, clickedToggle) {
    if (!clickedToggle) return 0;
    var li = clickedToggle.closest('.product__media-item[data-media-id]');
    if (!li) return 0;
    var mediaId = li.getAttribute('data-media-id');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].mediaId === mediaId) return i;
    }
    return 0;
  }

  function openFancyboxFor(clickedToggle) {
    var productInfo = clickedToggle.closest('product-info') || document.querySelector('product-info');
    if (!productInfo) return false;
    var slides = collectSlides(productInfo);
    if (!slides.length) return false;
    var startIdx = findStartIndex(slides, clickedToggle);
    jQuery.fancybox.open(slides, {
      loop: slides.length > 1,
      transitionEffect: 'fade',
      animationEffect: 'fade',
      hash: false,
      buttons: ['zoom', 'slideShow', 'fullScreen', 'close'],
      idleTime: 0,
      backFocus: false,
      clickContent: false,
      clickSlide: false,
      dblclickContent: 'zoom',
      dblclickSlide: 'close',
      touch: {
        vertical: false,
        momentum: true
      },
      keyboard: true,
      arrows: true,
      infobar: true
    }, startIdx);
    return true;
  }

  // Fancybox opens when either the fullscreen icon OR the image itself
  // is clicked. Swiper's own click-vs-drag detection ensures a swipe drag
  // is NOT treated as a click, so this doesn't interfere with swiping.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var trigger = e.target.closest(
      'product-info .product__media-icon, ' +
      'product-info .product__media-toggle, ' +
      'product-info .product__modal-opener'
    );
    if (!trigger) return;
    // Skip non-image media — Dawn's own video / 3D flow handles those.
    var li = trigger.closest('.product__media-item');
    if (li && li.classList.contains('product__media-item--full')) return;
    // Don't open Fancybox inside the Quick View modal — its in-modal
    // slider is for browsing only, not for zoom.
    if (trigger.closest('quick-add-modal')) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    openFancyboxFor(trigger);
  }, true);
})();

// ===== Product card color swatches — click to switch variant + image =====
// Uses EVENT DELEGATION on document so it also works for DOM nodes that are
// cloned by Owl Carousel (loop: true) or injected later by any AJAX.
(function () {
  function getVariants(card) {
    if (card.__ivyVariantsCache) return card.__ivyVariantsCache;
    var dataEl = card.querySelector('.card-variants-data');
    if (!dataEl) return null;
    try {
      var parsed = JSON.parse(dataEl.textContent.trim());
      if (Array.isArray(parsed) && parsed.length) {
        card.__ivyVariantsCache = parsed;
        return parsed;
      }
    } catch (e) {}
    return null;
  }

  function swapImage(img, newSrc) {
    if (!img || !newSrc) return;
    img.classList.add('ivy-swatch-img');
    img.classList.add('ivy-fading');
    var start = Date.now();
    var MIN_FADE = 240;
    var done = false;

    var doSwap = function () {
      if (done) return;
      done = true;
      img.removeAttribute('srcset');
      img.src = newSrc;
      // Force reflow, then fade back in
      // eslint-disable-next-line no-unused-expressions
      img.offsetHeight;
      img.classList.remove('ivy-fading');
    };

    var ready = function () {
      var waited = Date.now() - start;
      setTimeout(doSwap, Math.max(0, MIN_FADE - waited));
    };

    var preload = new Image();
    preload.onload = ready;
    preload.onerror = ready;
    preload.src = newSrc;
    setTimeout(ready, MIN_FADE + 400);
  }

  function handleSwatch(e, swatch) {
    var card = swatch.closest('.comm-product-card, .product-card');
    if (!card) return;
    var variants = getVariants(card);
    if (!variants) return;

    var optionPosition = parseInt(card.dataset.colorOptionPosition || '1', 10);
    var baseUrl = card.dataset.productUrl || '';
    var color = swatch.getAttribute('data-color');
    if (!color) return;
    var wanted = color.toLowerCase();
    var match = variants.find(function (v) {
      var opt = v['option' + optionPosition];
      return opt && String(opt).toLowerCase() === wanted;
    });
    if (!match) return;

    e.preventDefault();
    e.stopPropagation();

    var img = card.querySelector('.comm-product-img img, .product-img img');
    if (img && match.featured_image) swapImage(img, match.featured_image);

    var form = card.querySelector('form');
    var variantInput = form && form.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = match.id;

    var variantUrl = baseUrl ? baseUrl + '?variant=' + match.id : '';
    if (variantUrl) {
      var imgLink = card.querySelector('.comm-product-img a, .product-img a');
      var titleLink = card.querySelector('.comm-product-title-link, .product-info a');
      if (imgLink) imgLink.href = variantUrl;
      if (titleLink) titleLink.href = variantUrl;

      // Also point the Quick View opener at this variant so the modal
      // opens with the matching color pre-selected (Dawn's quick-add
      // modal fetches data-product-url and the variant query string
      // makes the loaded product-info select the right variant).
      card.querySelectorAll('[data-product-url]').forEach(function (el) {
        el.setAttribute('data-product-url', variantUrl);
      });
    }

    card.querySelectorAll('.product-swatches .swatch').forEach(function (s) {
      s.classList.remove('swatch-active');
    });
    swatch.classList.add('swatch-active');
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.product-swatches .swatch[data-color]');
    if (swatch) handleSwatch(e, swatch);
  });

  // Keyboard support (Enter / Space) — focus must be on a swatch
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var swatch = e.target && e.target.closest && e.target.closest('.product-swatches .swatch[data-color]');
    if (swatch) handleSwatch(e, swatch);
  });

  // Make swatches focusable / announced as buttons (runs on load + lazy inits)
  function enhanceSwatches(root) {
    (root || document).querySelectorAll('.product-swatches .swatch[data-color]').forEach(function (s) {
      if (s.__ivyEnhanced) return;
      s.__ivyEnhanced = true;
      s.setAttribute('role', 'button');
      s.setAttribute('tabindex', '0');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhanceSwatches(); });
  } else {
    enhanceSwatches();
  }
  document.addEventListener('shopify:section:load', function (e) {
    enhanceSwatches(e.target);
  });
  // Owl carousel clones slides after init — re-enhance then
  document.addEventListener('initialized.owl.carousel', function () { enhanceSwatches(); });
})();

// ===== Product card "Add to cart" — AJAX submit + open cart drawer =====
// Mirrors what <product-form> does on the product detail page, but as a
// document-level delegated handler so it works on every custom section
// (collection grid, home best-sellers, community/wineries/hotels grids, etc.)
(function () {
  function onCardSubmit(e) {
    var form = e.target.closest(
      '.comm-product-card form, .product-card form, .product-img form'
    );
    if (!form) return;
    var action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;

    e.preventDefault();

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart) {
      // No drawer installed — just submit normally
      form.submit();
      return;
    }

    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    if (btn) {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
    }

    var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
    };
    if (config.headers) {
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
    }

    var formData = new FormData(form);
    if (typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (s) { return s.id; })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }
    config.body = formData;

    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(cartAddUrl, config)
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          // Shopify error (variant unavailable etc.)
          console.warn('Cart add error:', response.description || response.message);
          return;
        }
        if (typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }
        // Ensure drawer opens even if renderContents doesn't auto-open
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (typeof cart.open === 'function') {
          try { cart.open(btn); } catch (err) { /* renderContents already opened it */ }
        }
        // Publish cartUpdate so other UI (header count) refreshes
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'card-add-to-cart',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        }
      })
      .catch(function (err) { console.error(err); })
      .finally(function () {
        if (btn) {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
        }
      });
  }

  document.addEventListener('submit', onCardSubmit);
})();

// ===== Header cart icon — open cart drawer instead of navigating to /cart =====
(function () {
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('.header-icon--cart');
    if (!cartLink) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    e.preventDefault();
    if (typeof drawer.open === 'function') {
      drawer.open(cartLink);
    } else if (drawer.classList) {
      drawer.classList.add('active');
      drawer.setAttribute('open', '');
    }
  });
})();

// ===== Product detail slider — Swiper.js powered =====
// We upgrade Dawn's <ul class="product__media-list"> into a Swiper slider
// for smooth mouse-drag + touch-swipe with proper momentum/snap and
// guaranteed image rendering on every slide change. Thumbnails on the
// side stay in sync via swiper.slideTo when clicked. Clicking the active
// image still opens the Fancybox lightbox (handled separately above).
(function () {
  if (typeof Swiper === 'undefined') return;

  function initGallerySwiper(gallery) {
    if (gallery.__ivySwiperInit) return;
    var insideModal = !!(gallery.closest && gallery.closest('quick-add-modal, [id^="QuickAddInfo-"]'));
    gallery.__ivySwiperInit = true;

    // Per-instance safety patch: replace onSlideChanged on THIS gallery
    // instance so Dawn's crashing read of `event.detail.currentElement.dataset`
    // never fires here, even if the prototype-level patch missed (timing race).
    gallery.onSlideChanged = function (event) {
      try {
        if (!event || !event.detail || !event.detail.currentElement) return;
        var ds = event.detail.currentElement.dataset;
        if (!ds || !ds.mediaId) return;
        if (!this.elements || !this.elements.thumbnails) return;
        var thumbnail = this.elements.thumbnails.querySelector('[data-target="' + ds.mediaId + '"]');
        if (thumbnail && typeof this.setActiveThumbnail === 'function') {
          this.setActiveThumbnail(thumbnail);
        }
      } catch (_) {}
    };

    var list = gallery.querySelector('.product__media-list');
    if (!list) return;
    var slides = list.querySelectorAll('.product__media-item');
    if (slides.length < 2) return;

    // Mark the host so CSS can switch from Dawn's display:none-based
    // single-slide visibility model to Swiper's transform-based one.
    list.classList.add('swiper', 'ivy-swiper-gallery');
    if (insideModal) list.classList.add('ivy-swiper-gallery--modal');

    // Swiper expects a .swiper-wrapper containing .swiper-slide children.
    // Wrap existing <li> items in-place.
    var wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';
    while (list.firstChild) wrapper.appendChild(list.firstChild);
    list.appendChild(wrapper);

    // Every <li> becomes a swiper-slide. Also drop `is-active` so Dawn's
    // CSS doesn't fight Swiper's own active-slide class.
    slides.forEach(function (li) {
      li.classList.add('swiper-slide');
      li.classList.remove('is-active');
    });

    // Mark first slide as active for Dawn-compatible CSS.
    slides[0].classList.add('is-active');

    // Make sure every image is set to eager-load — Swiper relies on
    // immediate layout/paint.
    list.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });

    var swiper = new Swiper(list, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: slides.length > 1,
      speed: 350,
      grabCursor: true,
      preloadImages: true,
      watchSlidesProgress: true,
      threshold: 5
    });

    gallery.__ivySwiper = swiper;

    // Dawn's SliderComponent disables the prev button on slide 1 (because
    // its scrollLeft-based math thinks we're at the start). In Swiper-loop
    // mode the prev/next are always available — so we strip the `disabled`
    // attribute and use a MutationObserver to keep it stripped if Dawn ever
    // re-adds it (e.g. on resize). Affects only this gallery's nav buttons.
    var navButtons = gallery.querySelectorAll(
      'slider-component:not(.thumbnail-slider) .slider-button--prev, ' +
      'slider-component:not(.thumbnail-slider) .slider-button--next'
    );
    navButtons.forEach(function (btn) {
      btn.removeAttribute('disabled');
      var obs = new MutationObserver(function () {
        if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
      });
      obs.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    });

    // Keep Dawn-style `is-active` class on the real (non-cloned) slide
    // so anything reading it (CSS, thumbnails, Dawn) sees the right one.
    swiper.on('slideChange', function () {
      var realIdx = swiper.realIndex;
      slides.forEach(function (li, i) {
        li.classList.toggle('is-active', i === realIdx);
      });

      // Sync thumbnail aria-current if a thumbnail strip exists.
      var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
      if (!thumbs) return;
      var mediaId = slides[realIdx] && slides[realIdx].getAttribute('data-media-id');
      if (!mediaId) return;
      thumbs.querySelectorAll('button[aria-current]').forEach(function (b) {
        b.removeAttribute('aria-current');
      });
      var thumbBtn = thumbs.querySelector('[data-target="' + mediaId + '"] button');
      if (thumbBtn) thumbBtn.setAttribute('aria-current', 'true');
    });

    // Thumbnail clicks → drive the swiper (instead of Dawn's setActiveMedia
    // which crashes on this page).
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var item = e.target.closest('[data-target]');
        if (!item) return;
        var target = item.getAttribute('data-target');
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === target) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();
            swiper.slideToLoop(i);
            return;
          }
        }
      }, true);
    }
  }

  // Expose for cross-IIFE access (the variant-change patch needs to rebuild
  // the modal Swiper on variant click).
  window.__ivyInitGallerySwiper = initGallerySwiper;

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(initGallerySwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Quick View modal injects a fresh <product-info> (including its own
  // <media-gallery>) into [id^="QuickAddInfo-"] every time it opens.
  // Observe those containers and run our Swiper init for any new gallery
  // that appears, so the in-modal slider gets the same drag/arrow behaviour.
  var modalObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;
        var galleries = [];
        if (node.tagName && node.tagName.toLowerCase() === 'media-gallery') {
          galleries.push(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('media-gallery').forEach(function (g) { galleries.push(g); });
        }
        galleries.forEach(initGallerySwiper);
      });
    });
  });
  function startObservingQuickAdd() {
    document.querySelectorAll('[id^="QuickAddInfo-"]').forEach(function (container) {
      if (container.__ivyObserved) return;
      container.__ivyObserved = true;
      modalObserver.observe(container, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObservingQuickAdd);
  } else {
    startObservingQuickAdd();
  }
  // Quick-add-modal nodes may upgrade later — also catch additions to body.
  var bodyObserver = new MutationObserver(function () { startObservingQuickAdd(); });
  bodyObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

// ===== Variant-change safety patches =====
// Dawn's <product-info> calls media-gallery.setActiveMedia and re-orders
// <li> items inside the gallery <ul> during a variant change. Both
// operations crash here because:
//   1) setActiveMedia dereferences an absent thumbnail (TypeError).
//   2) <li>s now live inside a <div.swiper-wrapper>, so Dawn's
//      `ul.insertBefore(li, ul.querySelector('li:nth-of-type'))` fails
//      with NotFoundError — the reference node isn't a direct <ul> child.
// When either throws, handleUpdateProductInfo halts before re-enabling
// the Add to Cart button, leaving it disabled until a page reload.
//
// We replace both with safe no-ops on the prototype level (covers all
// instances, present and future). The Swiper handles image display, so
// we don't need Dawn's media update path at all.
(function () {
  function patchPrototypes() {
    var pi = customElements.get('product-info');
    if (pi && pi.prototype && !pi.prototype.__ivyPatched) {
      pi.prototype.__ivyPatched = true;
      pi.prototype.updateMedia = function (_html, variantFeaturedMediaId) {
        // Dawn's original updateMedia re-orders <li> items inside the
        // gallery <ul> which crashes when our Swiper has wrapped them
        // in a .swiper-wrapper div. We skip that entire re-shuffle and
        // just point the Swiper at the new variant's featured image —
        // which is already a slide in our gallery.
        if (!variantFeaturedMediaId) return;
        try {
          var gallery = this.querySelector('media-gallery');
          if (gallery && typeof gallery.setActiveMedia === 'function') {
            var mediaId = (this.dataset.section || '') + '-' + variantFeaturedMediaId;
            gallery.setActiveMedia(mediaId, true);
          }
        } catch (_) {
          // Never let media sync break the variant-change flow.
        }
      };
    }
    var mg = customElements.get('media-gallery');
    if (mg && mg.prototype && !mg.prototype.__ivyPatched) {
      mg.prototype.__ivyPatched = true;

      // Dawn binds a `slideChanged` listener on its <slider-component> which
      // calls `onSlideChanged(event)` and blindly reads
      // `event.detail.currentElement.dataset.mediaId`. When Swiper takes over
      // (modal + main page), the slider-component is repurposed and that
      // event may fire with no detail at all — crashing the variant flow.
      // Make it a safe no-op; Swiper handles its own thumbnail sync.
      mg.prototype.onSlideChanged = function (event) {
        try {
          if (!event || !event.detail || !event.detail.currentElement) return;
          var ds = event.detail.currentElement.dataset;
          if (!ds || !ds.mediaId) return;
          if (!this.elements || !this.elements.thumbnails) return;
          var thumbnail = this.elements.thumbnails.querySelector('[data-target="' + ds.mediaId + '"]');
          if (thumbnail && typeof this.setActiveThumbnail === 'function') {
            this.setActiveThumbnail(thumbnail);
          }
        } catch (_) {
          // Swallow — never let Dawn's stale event break the variant flow.
        }
      };

      mg.prototype.setActiveMedia = function (mediaId /*, prepend */) {
        var gallery = this;
        try {
          var list = gallery.querySelector('.product__media-list');
          if (!list) return;
          var items = list.querySelectorAll('.product__media-item');
          var targetIdx = -1;
          var targetItem = null;
          for (var i = 0; i < items.length; i++) {
            if (items[i].getAttribute('data-media-id') === mediaId) {
              targetIdx = i;
              targetItem = items[i];
              break;
            }
          }
          if (targetIdx === -1 || !targetItem) return;

          // Both main and modal galleries use Swiper. Just slide to the
          // target. Use a robust find-by-data-media-id inside the Swiper's
          // slides so we never index a stale clone (loop mode adds clones).
          var swiper = gallery.__ivySwiper;
          if (!swiper) return;
          // Recompute idx against the Swiper's actual non-clone slides
          // (Swiper tags real slides with .swiper-slide and no `-duplicate-`).
          var realSlides = list.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
          var realIdx = -1;
          for (var k = 0; k < realSlides.length; k++) {
            if (realSlides[k].getAttribute('data-media-id') === mediaId) {
              realIdx = k;
              break;
            }
          }
          if (realIdx === -1) realIdx = targetIdx;
          try { swiper.update(); } catch (_) {}
          if (typeof swiper.slideToLoop === 'function') {
            swiper.slideToLoop(realIdx, 0);
          } else if (typeof swiper.slideTo === 'function') {
            swiper.slideTo(realIdx, 0);
          }
          // One more update on the next frame to clear any stale offsets
          // left over from a variant-change reflow.
          requestAnimationFrame(function () {
            try { swiper.update(); } catch (_) {}
          });
          setTimeout(function () {
            try { swiper.update(); } catch (_) {}
          }, 250);
        } catch (_) {
          // Swallow — never let our sync logic break the variant flow.
        }
      };
    }
  }

  // Custom elements may upgrade after our script runs. Try now, then on
  // DOMContentLoaded, then once more on load — cheap and idempotent.
  patchPrototypes();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchPrototypes);
  }
  window.addEventListener('load', patchPrototypes);

  // Most reliable: hook whenDefined — fires the instant the custom element
  // class is registered, even if our script loaded before Dawn's. This is
  // what guarantees the onSlideChanged + setActiveMedia patches actually
  // land on the prototype.
  if (window.customElements && typeof window.customElements.whenDefined === 'function') {
    window.customElements.whenDefined('product-info').then(patchPrototypes).catch(function () {});
    window.customElements.whenDefined('media-gallery').then(patchPrototypes).catch(function () {});
  }
})();
